var map = {
	"./jiaofu_0.png": "z1f9",
	"./jiaofu_1.png": "DqkJ",
	"./jiaofu_2.png": "rcJ1",
	"./jiaofu_3.png": "ABE1",
	"./jiaofu_4.png": "zsP0",
	"./jiaofu_5.png": "SgFw",
	"./jiaofu_bottom_bg.png": "2dNr",
	"./jiaofu_btn.png": "oRJ+",
	"./jiaofu_btn2.png": "6Dtk",
	"./jiaofu_info_icon1.png": "k4N2",
	"./jiaofu_info_icon2.png": "QHwx",
	"./jiaofu_info_icon3.png": "rsuA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BNV5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/jiaofu_.*\.png$
// module id = BNV5
// module chunks = 1